export const PACKAGE_TYPES = {
  FLIGHT_AND_STAY: "flight-and-stay",
  ONLY_STAY: "only-stay",
};

export const endpoints_keys = {
  keyds: "keyds",
  keydsMap: "keydsMap",
  airports: "airports",
  availabilities: "availabilities",
  search: "search",
  price: "price",
  details: "details",
  quote: "quote",
  book: "book",
  confirm: "confirm",
};
